import React, { useState, useEffect, useCallback } from 'react';
import './MiCuenta.css';
import { apiFetch } from '../../../services/dashboardApi';

function MiCuenta({ token }) {
    const [cuenta, setCuenta] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchMiCuenta = useCallback(async () => {
        try {
            setLoading(true);
            const response = await apiFetch('http://localhost:8000/api/usuarios/me/', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                const data = await response.json();
                setCuenta(data);
            } else {
                setError('Error al cargar información de la cuenta');
            }
        } catch (err) {
            setError('Error de conexión: ' + err.message);
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        fetchMiCuenta();
    }, [fetchMiCuenta]);

    if (loading) {
        return <div className="mi-cuenta-loading">Cargando información de tu cuenta...</div>;
    }

    if (error) {
        return <div className="mi-cuenta-error">{error}</div>;
    }

    if (!cuenta) {
        return <div className="mi-cuenta-empty">No se pudo cargar la información de la cuenta</div>;
    }

    const { user, roles, staff, socio } = cuenta;
    const socioVinculado = socio || staff?.socio || null;

    return (
        <div className="mi-cuenta-container">
            <h2>Mi Cuenta</h2>

            {/* Información del Usuario */}
            <div className="mi-cuenta-section">
                <h3>Información de Usuario</h3>
                <p><strong>Usuario:</strong> {user.username}</p>
                <p><strong>Email:</strong> {user.email || 'N/A'}</p>
                <p><strong>Nombre:</strong> {user.first_name} {user.last_name}</p>
                <p><strong>Tipo de cuenta:</strong> {user.is_superuser ? 'Superusuario' : user.is_staff ? 'Staff' : 'Usuario'}</p>
            </div>

            {/* Roles */}
            {roles && roles.length > 0 && (
                <div className="mi-cuenta-section roles-section">
                    <h3>Roles Asignados</h3>
                    <ul>
                        {roles.map(rol => (
                            <li key={rol.id}>
                                <strong>{rol.nombre}</strong> - {rol.descripcion}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Información del Socio vinculado */}
            {socioVinculado && (
                <div className="mi-cuenta-section socio-card">
                    <h3>Socio Vinculado</h3>

                    {socioVinculado.avatar && (
                        <div className="avatar-container">
                            <img
                                className="avatar-image socio-avatar"
                                src={socioVinculado.avatar.startsWith('http') ? socioVinculado.avatar : `http://localhost:8000/media/${socioVinculado.avatar}`}
                                alt="Avatar Socio"
                                onError={(e) => e.target.style.display = 'none'}
                            />
                        </div>
                    )}

                    <p><strong>Nombre:</strong> {socioVinculado.nombres} {socioVinculado.apellidos}</p>
                    <p><strong>Registro ABIS:</strong> {socioVinculado.reg_abis || 'N/A'}</p>
                    <p><strong>CI:</strong> {socioVinculado.ci || 'N/A'}</p>
                    <p><strong>Email:</strong> {socioVinculado.email || 'N/A'}</p>
                    <p><strong>Registro Profesional:</strong> {socioVinculado.nreg_profesional || 'N/A'}</p>
                </div>
            )}
        </div>
    );
}

export default MiCuenta;
